import Body from "./lib/body/Body";
import Header from "./lib/header/Header";
import PropTypes from "prop-types";
import React from "react";
import { backboneConnect } from "lib/common/hoc/BackboneReact/backboneConnect";

export default class SelectionTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDisabled: props.showDisabled
        };
    }

    onShowDisabledChange() {
        this.setState({
            showDisabled: !this.state.showDisabled
        });
    }

    getFilteredColumns() {
        const {hasStereotype, reportTypeKey, supportsEnablement, columns} = this.props;
        const filteredColumns = [...columns];

        // This assumes that the records can't have both
        // enablement and stereotype
        if(this.state.showDisabled) {
            if(supportsEnablement) {
                filteredColumns.push({
                    key: "_enabled",
                    name: "Enabled",
                    type: "string"
                });
            }
        }
        else {
            if(hasStereotype) {
                if (hasStereotype && reportTypeKey === "d") {
                    filteredColumns.push({
                        key: "_longname",
                        name: "Field",
                        type: "string"
                    });

                    filteredColumns.push({
                        key: "_message",
                        name: "Message",
                        type: "string"
                    });
                }
            }
        }
        return filteredColumns;
    }

    getFilteredCollection() {
        const {
            records,
            supportsEnablement
        } = this.props;
        const {showDisabled} = this.state;

        const filteredRecords = supportsEnablement ?
            records.filter(m => (showDisabled ? true : m.data._enabled === true))
            : records;
        return showDisabled ? records : filteredRecords;
    }

    render() {
        const {
            sorts,
            renderUnsafe,
            hasHover,
            supportsEnablement,
            fixedHeaders,
            onRecordSelection,
            onDownloadClick,
            onSort,
            sortable,
            selected,
            maxHeight = "auto",
        } = this.props;
        const records = this.getFilteredCollection();

        const filteredColumns = this.getFilteredColumns();

        const header = (
            <Header
                onSort={sortable ? onSort : null}
                columns={filteredColumns}
                sorts={sorts}
                fixedHeaders={fixedHeaders}
            />
        );

        const body = (
            <Body
                records={records}
                selected={selected}
                columns={filteredColumns}
                onRecordSelection={onRecordSelection}
                onDownloadClick={onDownloadClick}
                renderUnsafe={renderUnsafe}
            />
        );

        const enablement = supportsEnablement ? (
                <label
                    className="text-right showDisabled"
                    style={{paddingRight: 10 + "px", display: "block"}}
                >
                    <input 
                        type="checkbox"
                        onChange={this.onShowDisabledChange.bind(this)}
                        id="showDisabled"
                        defaultChecked={this.state.showDisabled ? "checked" : null}
                    /> Show Disabled Records
                </label>
        ) : null;

        return (
            <React.Fragment>
                {enablement}
                <div className={`search-results ${fixedHeaders ? "fixed-headers" : ""}`}>
                    <div className="scroll-container" style={{
                        maxHeight: supportsEnablement
                            ? `calc(${maxHeight} - 30px)`
                            : maxHeight,
                    }}>
                        <table className={hasHover ?
                                          "table-alt table-striped table-hover" :
                                          "table-alt table-striped"}>
                            <thead>
                                <tr>{header}</tr>
                            </thead>
                            <tbody>{body}</tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

SelectionTable.propTypes = {
    records: PropTypes.array,
    columns: PropTypes.array,
    fixedHeaders: PropTypes.bool,
    selected: PropTypes.object,
    sorts: PropTypes.object,
    showDisabled: PropTypes.bool,
    supportsEnablement: PropTypes.bool,
    hasHover: PropTypes.bool,
    hasStereotype: PropTypes.bool,
    renderUnsafe: PropTypes.bool,
    sortable: PropTypes.bool,
    onSort: PropTypes.func,
    reportTypeKey: PropTypes.string,
    onRecordSelection: PropTypes.func.isRequired,
    onDownloadClick: PropTypes.func,
    maxHeight: PropTypes.string,
};

SelectionTable.defaultProps = {
    fixedHeaders: false,
    records: [],
    columns: [],
    sorts: {},
    showDisabled: false,
    supportsEnablement: false,
    hasHover: true,
    sortable: true,
    renderUnsafe: true,
};

const config = props => ({
    records: {
        listenOn: "collection",
        get: (collection) => collection.map(it => ({...it.toJSON(), id: it.cid, _record: it}))
    },
    sorts: {
        listenOn: "sorts",
        event: "sort",
        get: () => props.sorts.toJSON()
    },
    selected: {
        listenOn: "collection",
        event: "selected",
        func: model => ({ selected: model.toJSON() })
    },
    columns: {
        listenOn: "fields",
        get: (fields) => fields.toJSON()
    },
    onRecordSelection: (record) => {
        if (!props.onRecordSelection) return;
        record._record.trigger("selected", record._record);
        props.onRecordSelection(record._record);
    },
    onSort: (column) => {
        const key = column.key;
        const sort = props.sorts ? props.sorts.get(key) : undefined;

        if (sort) {
            if (sort === "desc") {
                props.sorts.set(key, "asc");
            } else if (sort === "asc") {
                props.sorts.unset(key);
            }
        } else {
            props.sorts.set(key, "desc");
        }
        props.sorts.trigger("sort", props.sorts);
        props.onSort();
    },
});

export const BackboneSelectionTable = backboneConnect(config)(SelectionTable);



// WEBPACK FOOTER //
// ./app/lib/common/selectiontable/SelectionTable.js